import { toPercent } from '@shared/utils/percent';
import { TSparseSubmission } from '../types/submissions.types';

/**
 * Returns the progress percentage for a single submission entry in the
 * "submissions overview" (table) screen.  Here we have:
 *  - totalSelectedItems
 *  - acceptedSelectedItems
 */
const getOverviewProgress = (submission: TSparseSubmission): number => {
  return toPercent(submission.acceptedSelectedItems, submission.totalSelectedItems);
};

export default getOverviewProgress;
